const NAME = 'LEMNISK';
const CNameMapping = {
  [NAME]: NAME,
  'LEMNISK_MARKETING_AUTOMATION': NAME,
  'Lemnisk Marketing Automation': NAME,
  'LemniskMarketingAutomation': NAME,
  'lemniskmarketingautomation': NAME,
  'lemniskMarketingAutomation': NAME,
  'lemnisk': NAME,
  'Lemnisk': NAME,
};

export { NAME, CNameMapping };